import { Component, Input, OnInit, SimpleChanges, OnChanges, output } from "@angular/core";

@Component({
    selector: "wk-pagination-component",
    templateUrl: "./pagination-component.html",
    styleUrl: "./pagination-component.scss",
    standalone: false,
    host: { class: "wk-pagination" },
})
export class PaginationComponent implements OnInit, OnChanges {
    /** The total number of records */
    @Input()
    collectionSize = 0;

    /** The number of records to display */
    @Input()
    pageSize = 5;

    /** Current page */
    @Input()
    currentPage = 1;

    /** The number of buttons to show either side of the current page */
    @Input()
    maxSize = 3;

    /** Display the First/Last buttons */
    @Input()
    firstLastButtons = false;

    /** Display the Next/Previous buttons */
    @Input()
    nextPreviousButtons = true;

    /** Display small pagination buttons */
    @Input()
    small = false;
    readonly pageChange = output<any>();
    totalPages: any[] = [];
    totalDisplayPages: any[] = [];

    constructor() {}

    ngOnInit(): void {
        this.totalPages = [...Array(Math.ceil(this.collectionSize / this.pageSize)).keys()].map((i) => i + 1);
        this.setDisplayPages();
    }

    ngOnChanges(changes: SimpleChanges) {
        this.totalPages = [...Array(Math.ceil(this.collectionSize / this.pageSize)).keys()].map((i) => i + 1);
        this.setDisplayPages();
    }

    setDisplayPages() {
        if (this.totalPages.length <= 4) {
            this.totalDisplayPages = this.totalPages;
        } else {
            if (this.totalPages.length > this.currentPage + 2) {
                if (this.currentPage == 1 || this.currentPage == 2) {
                    this.totalDisplayPages = this.totalPages.slice(0, 4);
                } else {
                    this.totalDisplayPages = this.totalPages.slice(this.currentPage - 1, this.currentPage + 2);
                }
            } else {
                this.totalDisplayPages = this.totalPages.slice(this.totalPages.length - 3, this.totalPages.length);
            }
        }
    }

    /** Set page number */
    selectPageNumber(pageNumber: number) {
        this.currentPage = pageNumber;
        this.pageChange.emit(this.currentPage);
    }

    /** Set next page number */
    next() {
        const nextPage = this.currentPage + 1;
        nextPage <= this.totalPages.length && this.selectPageNumber(nextPage);
    }

    /** Set previous page number */
    previous() {
        const previousPage = this.currentPage - 1;
        previousPage >= 1 && this.selectPageNumber(previousPage);
    }
}
